var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:('width:' + _vm.width + 'px !important')},[_c('audio',{ref:"plyr",staticClass:"plyr",attrs:{"id":"player","playsinline":"","controls":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }